module.exports = __webpack_public_path__ + "static/media/rcmrd_logo.b2148e4f.png";